import { AbstractDataProviderV2, IDataProviderV2 } from 'components/system';
import { RsCustomerAction } from 'common/customers/services';

export type ICustomerActionDataProvider = IDataProviderV2<RsCustomerAction, {}, {}>;

export class CustomerActionDataProvider extends AbstractDataProviderV2<RsCustomerAction, {}, {}> implements ICustomerActionDataProvider {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{customerId}/actions');
    }

    public add() {
        return Promise.reject('Method `add` is not available');
    }

    public patch() {
        return Promise.reject('Method `patch` is not available');
    }

    public remove() {
        return Promise.reject('Method `remove` is not available');
    }

    public update() {
        return Promise.reject('Method `update` is not available');
    }
}
